import axios from 'axios'
import {VmView} from 'components'
import AlertOk from 'components/AlertOk'
import AlertYesNo from 'components/AlertYesNo'
import QueryString from 'qs'
import {useEffect, useRef, useState} from 'react'
import {toCurrency} from 'utils/functions'

export const ModalPilihObat = ({
  keywrd = '',
  isOpen,
  onClose,
  uid = 0,
  onSelectObat = () => {},
}) => {
  const refConfirmation = useRef()
  const resInformation = useRef()
  const [searchTerm, setSearchTerm] = useState('')
  const [items, setItems] = useState([])
  const [page, setPage] = useState(1)
  const [loading, setLoading] = useState(false)
  const [hasMore, setHasMore] = useState(true)
  const [keyword, setKeyword] = useState('')

  const fetchObat = async () => {
    if (loading || !hasMore) return // Prevent multiple requests
    setLoading(true)

    try {
      const {data: res} = await axios.post(
        process.env.REACT_APP_BASE_URL_DOKTER + '/prd-data-obat/index',
        QueryString.stringify({
          a: 'dk13',
          reg: 'dbdok',
          uid,
          offset: (page - 1) * 10,
          limit: 10,
          keyword,
        })
      )

      if (res) {
        setItems(prevItems => [...prevItems, ...res])
        setHasMore(res?.length > 0) // Check if more items are available
      } else {
        console.log('Error get Data Obat')
      }
    } catch (err) {
      console.log('Error get Data Obat', err.message)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (isOpen) fetchObat()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, keyword, isOpen])

  useEffect(() => {
    if (!isOpen) {
      setKeyword('')
      setSearchTerm('')
      setPage(1)
      setHasMore(true)
    }
  }, [isOpen])

  useEffect(() => {
    if (keywrd !== '') {
      setSearchTerm(keywrd)
      setKeyword(keywrd)
      setPage(1)
      setItems([])
      setHasMore(true)
    }
  }, [keywrd])

  if (!isOpen) return null

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 px-3">
      <div
        className="absolute inset-0 bg-black opacity-50"
        onClick={onClose}
      ></div>
      <VmView className="bg-white rounded-lg shadow-lg p-6 z-10 w-full md:w-1/2">
        <h2 className="text-xl font-semibold mb-4">Pilih Obat</h2>

        {/* Search Bar */}
        <div className="flex mb-4">
          <input
            type="text"
            value={searchTerm}
            onChange={e => {
              setSearchTerm(e.target.value)
            }}
            onKeyDown={e => {
              if (e.key === 'Enter') {
                setKeyword(searchTerm)
                setPage(1) // Reset to first page on new search
                setItems([]) // Clear previous items
                setHasMore(true)
              }
            }}
            placeholder="Cari Obat..."
            className="w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <button
            className="bg-blue-500 text-white p-2 rounded-lg ml-2"
            onClick={() => {
              setKeyword(searchTerm)
              setItems([])
              setPage(1)
              setHasMore(true)
            }}
          >
            Cari
          </button>
        </div>

        <VmView className="max-h-[70vh] overflow-auto">
          {items.length > 0 ? (
            items.map((item, index) => (
              <VmView
                key={index}
                className="mb-4 border-b-2 pb-2 flex justify-between items-center"
              >
                <div>
                  <label className="block text-gray-900 mb-1">
                    {item?.obatnama}
                  </label>
                  <label className="block text-gray-700 mb-1 text-sm">
                    {item?.obatkode}
                  </label>
                  <label className="block text-blue-600 mb-1 text-sm">
                    Rp. {toCurrency(item?.satuanObat[0]?.hj1 ?? 0)} /
                    {item[0]?.sonama}
                  </label>
                </div>
                <button
                  onClick={() => onSelectObat(item)}
                  className="bg-blue-500 text-white text-xs p-1 rounded-lg"
                >
                  Pilih
                </button>
              </VmView>
            ))
          ) : !loading && (
            <div className="text-gray-500">Tidak ada obat yang ditemukan.</div>
          )}
          {hasMore && (
            <div className="flex justify-center mt-4">
              <button
                onClick={() => setPage(prevPage => prevPage + 1)}
                className="bg-gray-300 text-black text-xs p-2 rounded-lg"
                disabled={loading}
              >
                {loading ? 'Loading...' : 'Load More'}
              </button>
            </div>
          )}
        </VmView>

        <button
          onClick={onClose}
          className="mt-4 bg-blue-500 text-white p-2 rounded-lg"
        >
          Tutup
        </button>
      </VmView>

      <AlertOk ref={resInformation} />
      <AlertYesNo ref={refConfirmation} />
    </div>
  )
}
